import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Main, Calendar } from '../../components';
import CalendarLegend from '../../components/Calendar/Legend';
import Page from '../../containers/Page';
import useClasses from '../../hooks/useClasses';
import useDailyRegistrations from '../../hooks/useDailyRegistrations';

import './style.scss';

const PageCalendar: React.FC = () => {
  const { t } = useTranslation();
  const { buildClass } = useClasses('Calendar');
  const { registrations } = useDailyRegistrations();

  const {
    calendarItems,
    startDate,
    endDate,
  } = useMemo(() => {
    const dateKeys = Object.keys(registrations).filter((date) => (
      // Date should occur before today or be today.
      new Date(date).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)
    ));

    const start = new Date(dateKeys[0]);
    const end = new Date(dateKeys[dateKeys.length - 1]);

    // We'll set the start date to the start of the month.
    start.setDate(1);

    // We'll set the end date to the end of the month.
    end.setMonth(end.getMonth() + 1);
    end.setDate(0);

    const items = dateKeys.map((date) => {
      const registrationData = registrations[date];
      const registered = registrationData.totalAmount != null;
      const goalIsSet = registrationData.goal !== null;
      const success = goalIsSet && registrationData.totalAmount <= registrationData.goal;
      const failed = goalIsSet && registrationData.totalAmount > registrationData.goal;

      return {
        start: date,
        registered,
        success,
        failed,
      };
    });

    return {
      calendarItems: items,
      startDate: start,
      endDate: end,
    };
  }, [registrations]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Page className={buildClass()} title={t('pages.calendar.title')}>
      <Main className="col-lg-6 offset-lg-1 py-8 py-lg-12">
        <div className="row">
          <div className="Page__introduction col-12">
            <h1>{t('pages.calendar.title')}</h1>
          </div>
          <div className="Page__content Page__content__Calendar col-12">
            <Calendar
              items={calendarItems}
              startDate={startDate}
              endDate={endDate}
            />
            <CalendarLegend />
          </div>
        </div>
      </Main>
    </Page>
  );
};

export default PageCalendar;
